const WHITE_BACKGROUND_MODULES = ['product', 'taxon_products', 'three_ways'];

const isModuleBackgroundWhite = (moduleName) => WHITE_BACKGROUND_MODULES.includes(moduleName);

export default isModuleBackgroundWhite;
